export const CONTENT_CONFIGS = {
  events: {
    kind: "events",
    label: "Events",
    singular: "event",
    columns: ["title", "starts_at", "speaker", "format"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "starts_at", label: "Start date & time", type: "datetime", required: true },
      { key: "ends_at", label: "End date & time", type: "datetime" },
      { key: "location", label: "Venue name", type: "text" },
      { key: "address_line1", label: "Address line 1", type: "text" },
      { key: "address_line2", label: "Address line 2", type: "text" },
      { key: "city", label: "City / town", type: "text" },
      { key: "postcode", label: "Postcode", type: "text" },
      { key: "venue_url", label: "Venue website URL", type: "text" },
      { key: "map_url", label: "Map / what3words URL", type: "text" },
      { key: "format", label: "Format", type: "select", options: ["in-person", "hybrid", "online"] },
      { key: "online_platform", label: "Online platform", type: "select", options: ["teams", "zoom", "other"] },
      { key: "online_url", label: "Online join URL", type: "text" },
      { key: "online_meeting_id", label: "Meeting ID", type: "text" },
      { key: "online_passcode", label: "Passcode", type: "text" },
      { key: "speaker", label: "Speaker", type: "text" },
      { key: "speaker_linkedin_url", label: "Speaker LinkedIn URL", type: "text" },
      { key: "abstract", label: "Abstract", type: "textarea" },
      { key: "registration_url", label: "Registration URL (external)", type: "text" },
      { key: "recording_url", label: "Recording URL", type: "text" },
      { key: "pillar", label: "Value pillar", type: "select", options: ["connect", "educate", "inspire", "secure"] },
      { key: "cpe_credits", label: "CPE credits", type: "number" },
      { key: "cpe_type", label: "CPE type", type: "select", options: ["group_a", "group_b"], default: "group_a" },
      { key: "cpe_domains", label: "CPE domains (comma-separated)", type: "text" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
  sponsors: {
    kind: "sponsors",
    label: "Sponsors",
    singular: "sponsor",
    columns: ["name", "tier", "url"],
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "tier", label: "Tier", type: "select", options: ["platinum", "gold", "silver", "community", "partner"] },
      { key: "logo_url", label: "Logo URL", type: "text" },
      { key: "url", label: "Website URL", type: "text" },
      { key: "blurb", label: "Blurb", type: "textarea" },
      { key: "amount", label: "Contribution (£)", type: "number" },
      { key: "paid_on", label: "Contribution date", type: "date" },
      { key: "sort_order", label: "Sort order", type: "number" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
  packages: {
    kind: "packages",
    label: "Sponsorship packages",
    singular: "package",
    columns: ["name", "price"],
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "price", label: "Price", type: "text" },
      { key: "deliverables", label: "Deliverables (one per line)", type: "textarea" },
      { key: "sort_order", label: "Sort order", type: "number" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
  resources: {
    kind: "resources",
    label: "Resources",
    singular: "resource",
    columns: ["title", "category", "kind"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "url", label: "URL", type: "text", required: true },
      { key: "kind", label: "Type", type: "select", options: ["link", "doc"] },
      { key: "category", label: "Category", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "sort_order", label: "Sort order", type: "number" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
  posts: {
    kind: "posts",
    label: "News posts",
    singular: "post",
    columns: ["title", "slug", "published_at"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "slug", label: "Slug (URL)", type: "text", required: true },
      { key: "excerpt", label: "Excerpt", type: "text" },
      { key: "body", label: "Body", type: "textarea" },
      { key: "published_at", label: "Publish date (blank = draft)", type: "datetime" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
  faqs: {
    kind: "faqs",
    label: "FAQs",
    singular: "FAQ",
    columns: ["question", "category"],
    fields: [
      { key: "question", label: "Question", type: "text", required: true },
      { key: "answer", label: "Answer", type: "textarea", required: true },
      { key: "category", label: "Category", type: "text" },
      { key: "sort_order", label: "Sort order", type: "number" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
  gallery: {
    kind: "gallery",
    label: "Gallery",
    singular: "image",
    columns: ["caption", "album", "image_url"],
    fields: [
      { key: "image_url", label: "Image URL", type: "text", required: true },
      { key: "caption", label: "Caption", type: "text" },
      { key: "album", label: "Album", type: "text" },
      { key: "sort_order", label: "Sort order", type: "number" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
  compliance: {
    kind: "compliance",
    label: "Compliance items",
    singular: "item",
    columns: ["title", "status", "due_on", "category"],
    fields: [
      { key: "title", label: "Requirement", type: "text", required: true },
      { key: "category", label: "Category", type: "text" },
      { key: "status", label: "Status", type: "select", options: ["todo", "in_progress", "done", "na"] },
      { key: "due_on", label: "Due date", type: "date" },
      { key: "notes", label: "Notes", type: "textarea" },
      { key: "sort_order", label: "Sort order", type: "number" },
    ],
  },
  speakers: {
    kind: "speakers",
    label: "Speakers",
    singular: "speaker",
    columns: ["name", "title", "topics", "is_public"],
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "title", label: "Job title", type: "text" },
      { key: "topics", label: "Topics", type: "text" },
      { key: "email", label: "Email", type: "text" },
      { key: "photo_url", label: "Photo URL", type: "text" },
      { key: "bio", label: "Bio", type: "textarea" },
      { key: "sort_order", label: "Sort order", type: "number" },
      { key: "is_public", label: "Approved (public)", type: "bool", default: true },
    ],
  },
  working_groups: {
    kind: "working_groups",
    label: "Working groups",
    singular: "group",
    columns: ["name", "focus_area", "lead_name", "status"],
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "focus_area", label: "Focus area", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "lead_name", label: "Lead name", type: "text" },
      { key: "lead_email", label: "Lead email", type: "text" },
      { key: "cadence", label: "Cadence", type: "text" },
      {
        key: "status",
        label: "Status",
        type: "select",
        options: ["forming", "active", "paused", "archived"],
      },
      { key: "is_public", label: "Public", type: "bool", default: true },
      { key: "sort_order", label: "Sort order", type: "number" },
    ],
  },
  finance: {
    kind: "finance",
    label: "Ledger entries",
    singular: "entry",
    lockedField: "source_type",
    columns: ["entry_date", "description", "category", "kind", "amount", "reconciled"],
    fields: [
      { key: "entry_date", label: "Date", type: "date", required: true },
      { key: "kind", label: "Type", type: "select", options: ["income", "expense"], required: true },
      { key: "amount", label: "Amount (£)", type: "number", required: true },
      { key: "category", label: "Category", type: "text" },
      { key: "description", label: "Description", type: "text" },
      { key: "method", label: "Method", type: "text" },
      { key: "reconciled", label: "Reconciled", type: "bool", default: false },
    ],
  },
  jobs: {
    kind: "jobs",
    label: "Jobs",
    singular: "job",
    columns: ["title", "company", "location", "closes_on"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "company", label: "Company", type: "text" },
      { key: "location", label: "Location", type: "text" },
      { key: "url", label: "Apply URL", type: "text" },
      { key: "closes_on", label: "Closes on", type: "date" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "sort_order", label: "Sort order", type: "number" },
      { key: "is_public", label: "Public", type: "bool", default: true },
    ],
  },
};
